export default "__VITE_ASSET__ebc8a7e9__"